// Central style configuration for all fenceline chart components.
// Adjust values here to update charts globally.

export const FencelineChartConfig = {
  // Chart dimensions
  height: 350,

  // Font sizes
  tickFontSize: 15,
  legendFontSize: 14,

  // Padding: space reserved around the plot area for axes and labels
  // bottom must be large enough for rotated (60°) tick labels at the chosen font size
  padding: {
    single: { top: 20, bottom: 100, left: 65, right: 20 },
    multi:  { top: 55, bottom: 130, left: 90, right: 50 },
  },

  // Bar width as a ratio of the available slot (0–1).
  // normal: used when ≤ 30 bars — bars fill the container width, slight gap looks good.
  // dense:  used when > 30 bars — bars are tighter to pack more into the scrollable area.
  barRatio: {
    normal: 0.6,
    dense:  0.8,
  },

  // Pixels allocated per bar when the chart needs to scroll (n > 30).
  // ≤ 30 bars always fit in containerWidth with no scrolling.
  scrollPerLabel: 40,
};
